export const SHARE_CARD = {
  IMAGE_GENERATION_FAIL: 'IMAGE_GENERATION_FAIL',
};
